import OptionsPanel from "./OptionsPanel.js"

export default class FontSize extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Font Size" // TODO: This needs to be localized
    this.setting = "size"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
